import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'bars',
            name: 'bar',
            class: 'Modules\\Bar\\Entities\\Bar',
            forms: {
                HOME_VIDEO: 'textarea-bars-form',
                EXTRACT_OF_TERMS: 'textarea-bars-form',
                PRIVACY_NOTICE: 'docs-bars-form',
                TERMS_AND_CONDITIONS: 'docs-bars-form',
                TYPES_BY_ALPHABET: 'tags-bars-form'
            },
            defaultBarsForm: 'default-bars-form'
        }
    },

    methods: {
        addForm(barName, component) {
            this.forms[barName] = component

            return this
        },

        getForm(barName) {
            return this.forms[barName] ?? this.defaultBarsForm
        }
    }
}